import axios from 'axios';
import config from '@/config/constants.js';

export default {
	namespaced: true,
	state: {
		status: '',
		services: [],
		submitProgress: 0,
		submitTotal: 0,
	},
	mutations: {
		loading(state) {
			state.status = 'loading';
		},
		status(state, status) {
			state.status = status;
		},
		success(state) {
			state.status = '';
			state.submitProgress = 0;
			state.submitTotal = 0;
		},
		setSubmitTotal(state, total) {
			state.submitTotal = total;
			state.submitProgress = 0;
		},
		incrementProgress(state) {
			state.submitProgress++;
		},
		addServices(state, services) {
			state.services = [];
			for (const prop in services) {
				state.services.push({
					text: services[prop].name,
					value: services[prop].name,
				});
			}

			if (state.services.length > 12) {
				state.services.push({
					text: 'Other',
					value: ''
				});
			}
		},
	},
	actions: {
		add_vendors: function ({
			commit
		}, vendors) {
			commit('loading');

			// eslint-disable-next-line no-async-promise-executor
			return new Promise(async function (resolve) {
				commit('setSubmitTotal', vendors.length);
				let contErrors = 0;
				let data_to_save = [];
				for (let i in vendors) {
					let vendor = vendors[i];

					// ?? iOS compatible: usar replace con regex en lugar de replaceAll
					let cleanPhone = vendor.phone_number.replace(/\s/g, '').replace(/-/g, '');

					data_to_save.push({
						first_name: vendor.first_name,
						last_name: vendor.last_name,
						email: vendor.email,
						phone_number: config.phone_extension + cleanPhone,
						service: vendor.service === '' ? vendor.service_other : vendor.service,
						company_name: vendor.company_name
					});
				}

				for (let i in data_to_save) {
					try {
						await axios.post(config.api_url + 'add_vendor', data_to_save[i]);
						vendors[i]['error'] = '';
					} catch (error) {
						contErrors++;
						vendors[i]['error'] = error.response.data.message;
					}
					commit('incrementProgress');
				}

				commit('success');
				resolve(contErrors);
			});
		},
		async get_services({ commit }) {
			try {
				const { data } = await axios.get(config.api_url + "servises");

				const services = data?.servises || [];

				commit("addServices", services);

				return services;
			} catch (error) {
				console.error("get_services error:", error);

				// ?? devolver vaco pero NO romper la app
				commit("addServices", []);
				return [];
			}
		},
	},
	getters: {
		user(state) {
			return state.user;
		},
		billing(state) {
			return state.billing;
		},
	},
	modules: {},
};